// src/pages/Listnotepads/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./CollectionPage";
import { getListNotepads, PRODUCTS_PER_PAGE } from "../data/listNotepads";
import SEOHead from "../components/common/SEOHead";
import ProductListSchema from "../components/common/ProductListSchema";
import FAQSchema from "../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/list-notepads";

const listNotepadFAQs = [
  {
    question: "What can I use a list notepad for?",
    answer: "List notepads are perfect for to-do lists, grocery lists, packing lists, and daily task tracking.",
  },
  {
    question: "Can I personalize the notepad cover with my name?",
    answer: "Yes, every notepad can be customized with your name, initials, or a custom design on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized notepads are made to order and typically ship within 6 working days across India.",
  },
];

export default function Listnotepads() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getListNotepads()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="List Notepads | Personalized Notepads"
      description="Shop 300+ beautifully designed personalized list notepads. Premium quality, customizable — perfect for every kind of list-maker."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "List Notepads", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/list-notepads",
    announcement: {
      headline: "New: List Notepads for every kind of list-maker!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: " Notepads",
      subtitle: "Every list, beautifully written",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "The prettiest notepad on my desk — and actually the most useful one too.",
      quoteLink: "#",
      rating: "4.6",
      ratingCount: "500+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={listNotepadFAQs} />
      <CollectionPage config={config} />
    </>
  );
}